import { render, staticRenderFns } from "./signedC.vue?vue&type=template&id=245dad8c&"
import script from "./signedC.vue?vue&type=script&lang=js&"
export * from "./signedC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports